import IntersectionHydrator from './IntersectionHydrator';
import { registrations } from '../registrations';
new IntersectionHydrator(registrations);
